<template>
  <v-avatar
    v-if="count > 0"
    :size="measures.size"
    :style="{ top: top, right: right }"
    color="primary"
  >
    <span
      :style="{ 'font-size': `${measures.fontSize}px !important` }"
      class="white--text"
    >
      {{ count }}
    </span>
  </v-avatar>
</template>

<script>
export default {
  name: 'NotificationCount',
  props: {
    count: {
      type: Number,
      required: true,
    },
    top: {
      type: String,
      required: true,
    },
    right: {
      type: String,
      required: true,
    },
    measures: {
      type: Object,
      default: () => {
        return {
          size: 20,
          fontSize: 12,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.count-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--v-primary-base);
  font-size: 12px;
  color: white;
  width: 20px;
  height: 20px;
  position: absolute;
}
</style>
